import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uomDisplay',
  standalone: true,
})
export class UomDisplayPipe implements PipeTransform {
  transform(uomId :number, unitOfMeasures :any[] = []) :unknown {
    if (!uomId || !unitOfMeasures.length) {
      return '';
    }

    return unitOfMeasures.find((uom) => uom.id === uomId)?.name || '';
  }
}
